import React from "react";
import LegalPageShell from "@/components/LegalPageShell";

const PrivacyPolicy = () => (
  <LegalPageShell
    dictionaryKey="privacy"
    testid="privacy-page"
    sectionKeys={["responsible", "data", "purposes", "rights", "transfers", "changes"]}
  />
);

export default PrivacyPolicy;
